import styled from 'styled-components';

import CustomTableHeader from './CustomTableHeader';
import CustomTableBody from './CustomTableBody';
import CustomTableFooter from './CustomTableFooter';

const TableStyled = styled.table.attrs(({columns}) => ({
  'aria-colcount': columns.length,
}))`
  border: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
`;

const CustomTable = ({getCssClasses, ...props}) => {
  const {columns, summary} = props;

  return (
    <TableStyled columns={columns} summary={summary}>
      <CustomTableHeader {...props} />
      <CustomTableBody {...props} getCssClasses={getCssClasses} />
      <CustomTableFooter {...props} />
    </TableStyled>
  );
};

export default CustomTable;
